// Import the city/district data
import cityDistrictData from '../assets/CityCountyData.json';

const addressService = {
  // Get all cities
  getAllCities: () => {
    return cityDistrictData.map(city => ({
      name: city.CityName,
      engName: city.CityEngName
    }));
  },

  // Get districts by city name
  getDistrictsByCity: (cityName) => {
    const city = cityDistrictData.find(c => c.CityName === cityName);
    if (!city) return [];
    
    return city.AreaList.map(area => ({
      zipCode: area.ZipCode,
      name: area.AreaName,
      engName: area.AreaEngName
    }));
  },
  
  // Get zip code by city and district
  getZipCode: (cityName, districtName) => {
    const city = cityDistrictData.find(c => c.CityName === cityName);
    if (!city) return null;
    
    const district = city.AreaList.find(a => a.AreaName === districtName);
    return district ? district.ZipCode : null;
  },
  
  // Format full address with zip code
  formatAddress: (cityName, districtName, detailAddress) => {
    if (!cityName || !districtName) return detailAddress || '';
    
    const zipCode = addressService.getZipCode(cityName, districtName);
    const addressParts = [zipCode, cityName, districtName, detailAddress].filter(Boolean);
    return addressParts.join(' ');
  },
  
  // Parse address into components
  parseAddress: (fullAddress) => {
    if (!fullAddress) {
      return {
        cityName: '',
        districtName: '',
        zipCode: '',
        detailAddress: ''
      };
    }
    
    // Try to match known cities and districts
    for (const city of cityDistrictData) {
      if (fullAddress.includes(city.CityName)) {
        for (const district of city.AreaList) {
          if (fullAddress.includes(district.AreaName)) {
            // Remove city and district from the full address to get detail address
            let detailAddress = fullAddress
              .replace(city.CityName, '')
              .replace(district.AreaName, '')
              .replace(district.ZipCode, '')
              .trim();
            
            return {
              cityName: city.CityName,
              districtName: district.AreaName,
              zipCode: district.ZipCode,
              detailAddress: detailAddress
            };
          }
        }
        
        // If district not found but city was found
        return {
          cityName: city.CityName,
          districtName: '',
          zipCode: '',
          detailAddress: fullAddress.replace(city.CityName, '').trim()
        };
      }
    }
    
    // If no match found, return the full address as detailAddress
    return {
      cityName: '',
      districtName: '',
      zipCode: '',
      detailAddress: fullAddress
    };
  }
};

export default addressService;